import React, { createContext, useState } from 'react';

export const ShortMsgTextContext = createContext();

const ShortMsgTextProvider = ({ children }) => {
  const [tempDetails, setTempDetails] = useState({});
  const [focusedEditor, setFocusedEditor] = useState(undefined);
  const [voiceName, setVoiceName] = useState(undefined);
  const [callLength, setCallLength] = useState(0);
  const [whatsappLength, setWhatsappLength] = useState(0);
  const [messageLength, setMessageLength] = useState(0);
  const [isDraft, setIsDraft] = useState(false);
  const [currentEnv, setCurrentEnv] = useState('draft');

  return (
    <ShortMsgTextContext.Provider
      value={{
        tempDetails,
        setTempDetails,
        focusedEditor,
        setFocusedEditor,
        isDraft,
        setIsDraft,
        voiceName,
        setVoiceName,
        whatsappLength,
        setWhatsappLength,
        messageLength,
        setMessageLength,
        callLength,
        setCallLength,
        currentEnv,
        setCurrentEnv,
      }}
    >
      {children}
    </ShortMsgTextContext.Provider>
  );
};

export default ShortMsgTextProvider;
